/* eslint-disable no-undef, class-methods-use-this, prefer-destructuring, no-param-reassign, spaced-comment */
class Forms {
	constructor() {
		this.init();
	}

	init() {}

	newForm(form) {
		this.formPrivacyPolicy = document.getElementById("input-form");
		this.formSendButton = document.getElementsByClassName("contact-button")[0];

		// Make sure the privacy policy value is unchecked
		this.formPrivacyPolicy.checked = false;
		this.formPrivacyPolicy.value = "unchecked";

		// Listen for privacy policy checkbox changes
		this.formPrivacyPolicy.addEventListener(
			"change",
			this.privacyPolicyCheckboxToogle
		);

		// Prevent form submit
		form.addEventListener("submit", this.preventFormSubmit);

		// Form validations and submit
		this.formSendButton.addEventListener("click", this.submitValidateForm);

		// Enable submit button
		this.formSendButton.disabled = false;
		// Load Re-captcha V3 or throw an error
		if (googleRecaptchaWebKey) {
			// eslint-disable-line
			/*
			if (window.captchaLoaded === false) {
				window.loadJS(
					`https://www.google.com/recaptcha/api.js?render=${googleRecaptchaWebKey}`,
					() => {
						window.captchaLoaded = true;
					}
				);
			}*/
		}
		else {
			console.error("Set up the Google ReCaptcha V3 keys"); // eslint-disable-line no-console
		}
	}

	privacyPolicyCheckboxToogle(privacyPolicyCheckbox) {
		if (privacyPolicyCheckbox.srcElement.value === "unchecked") {
			privacyPolicyCheckbox.srcElement.value = "checked";
		}
		else {
			privacyPolicyCheckbox.srcElement.value = "unchecked";
		}
	}

	preventFormSubmit(evt) {
		evt.preventDefault();
	}

	submitValidateForm(evt) {
		// Get the form parameters
		const action = "contact_form";
		const categories = this.form.querySelectorAll(
			"[name=categories]:checked"
		)[0];
		const firstName = this.form.querySelectorAll("[name=first_name]")[0];
		const email = this.form.querySelectorAll("[name=email]")[0];
		const city = this.form.querySelectorAll("[name=city]")[0];
		const companyName = this.form.querySelectorAll("[name=company_name]")[0];
		const phone = this.form.querySelectorAll("[name=phone_number]")[0];
		const subject = this.form.querySelectorAll("[name=subject]")[0];
		const file = this.form.querySelectorAll("[name=attachment_file]")[0];
		const message = this.form.querySelectorAll("[name=message]")[0];
		const messageIsRequired = this.form.querySelectorAll(
			"[name=user_message_required]"
		)[0];
		const receiverEmail = this.form.querySelectorAll(
			"[name=receiver_email]"
		)[0];
		const privacyPolicy = this.form.querySelectorAll(
			"[name=privacy_policy]"
		)[0];
		const isNewsletter = this.form.getElementsByClassName("is_newsletter")[0];
		const newsletterSubscription = this.form.getElementsByClassName(
			"newsletter_subscription"
		)[0];
		const successMessage = document.querySelectorAll(
			'[name="success_message"]'
		);
		const errorMessage = document.querySelectorAll('[name="error_message"]');
		const validationMessage = document.querySelectorAll(
			'[name="validation_message"]'
		);

		/* eslint-disable */
		const notificationMessage =
			document.getElementsByClassName("notification-text")[0];
		/* eslint-endable */
		const currentLanguage = encodeURI(scriptsAjaxVariables.current_language); // eslint-disable-line
		const defaultLanguage = encodeURI(scriptsAjaxVariables.default_language); // eslint-disable-line
		const formData = new FormData();
		formData.append("action", action);

		if (categories) {
			formData.append("category", categories.value);
		}

		if (firstName) {
			formData.append("first_name", firstName.value);
		}

		if (email) {
			formData.append("email", email.value);
		}

		if (city) {
			formData.append("city", city.value);
		}

		if (companyName) {
			formData.append("company_name", companyName.value);
		}
		if (phone) {
			formData.append("phone_number", phone.value);
		}
		if (subject) {
			formData.append("subject", subject.value);
		}

		if (file) {
			formData.append("attachment_file", file.files[0]);
		}

		if (message) {
			formData.append("message", message.value);
		}

		if (messageIsRequired) {
			formData.append("user_message_required", messageIsRequired.value);
		}

		if (receiverEmail) {
			formData.append("receiver_email", receiverEmail.value);
		}

		if (privacyPolicy) {
			formData.append("privacy_policy", privacyPolicy.value);
		}

		if (isNewsletter) {
			formData.append("is_newsletter", isNewsletter.value);
		}

		if (newsletterSubscription.checked) {
			formData.append(
				"newsletter_subscription",
				newsletterSubscription.checked
			);
		}

		if (currentLanguage) {
			formData.append("current_language", currentLanguage);
		}

		if (defaultLanguage) {
			formData.append("default_language", defaultLanguage);
		}

		// Disable and animate the submit button
		evt.srcElement.disabled = true;
		evt.srcElement.classList.add("validating");

		// Ajax form submit
		const xmlhttp = window.ajaxReq();
		const url = encodeURI(scriptsAjaxVariables.ajax_url); // eslint-disable-line
		xmlhttp.open("POST", url, true); // set true for async, false for sync request
		xmlhttp.send(formData); // or null, if no parameters are passed

		// Validation
		xmlhttp.onreadystatechange = () => {
			if (xmlhttp.readyState === 4 && xmlhttp.status === 200) {
				try {
					const data = JSON.parse(xmlhttp.responseText);

					// Hide previous errors
					firstName.classList.remove("show-error");
					email.classList.remove("show-error");
					privacyPolicy.classList.remove("show-error");

					if (message) {
						message.classList.remove("show-error");
					}

					if (file) {
						file.classList.remove("show-error");
					}

					if (data.validation === false) {
						// Show errors
						if (data.first_name) {
							firstName.classList.add("show-error");
						}
						if (data.email) {
							email.classList.add("show-error");
						}
						if (data.phone_number) {
							phone.classList.add("show-error");
						}
						if (data.city) {
							city.classList.add("show-error");
						}
						if (data.company_name) {
							companyName.classList.add("show-error");
						}
						if (data.message) {
							message.classList.add("show-error");
						}
						if (data.privacy_policy) {
							privacyPolicy.classList.add("show-error");
						}

						// Validation Message.
						successMessage[0].style.display = "none";
						errorMessage[0].style.display = "none";
						validationMessage[0].style.display = "flex";

						// Scroll to the first error.
						const elementsWithError =
							evt.srcElement.form.getElementsByClassName("show-error");
						elementsWithError[0].scrollIntoView({
							block: "center",
							behavior: "smooth",
						});
					}
					else if (data.success === false) {
						// Error notification message
						successMessage[0].style.display = "none";
						errorMessage[0].style.display = "flex";
						validationMessage[0].style.display = "none";
					}
					else {
						// Success notification message
						successMessage[0].style.display = "flex";
						errorMessage[0].style.display = "none";
						validationMessage[0].style.display = "none";

						// Clear the form
						evt.srcElement.form.reset();
					}

					// Enable and stop the submit button animation
					evt.srcElement.disabled = false;
					evt.srcElement.classList.remove("validating");
				}
				catch (error) {
					console.log(error); // eslint-disable-line no-console
				}
			}
		};

		// Recaptcha validation
		/*
		grecaptcha.ready(() => {
			grecaptcha.execute(googleRecaptchaWebKey, { action }).then((token) => {
				if (token) {
					formData.append("token", token);
				}
			});
		});
		*/
	}
}

export default Forms;
